import React, { useRef, useEffect, useContext, useState } from "react";
import ProjectContext from "../../context/ProjectContext";

const ShapesComp = ({
  value,
  EditorZoom,
  index,
  CanvasDisplay,
  InLock,
  AciveShapeColor,
  setAciveShapeColor,
  fromPreview
}) => {
  const { LayersData, setLayersData } = useContext(ProjectContext);

  const SvgRef = useRef(null);

  const Update = (call) => {
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key == value.key) {
        array[i].strokeColor = null;
        array[i].stroke = 0;
        array[i].svgContent = SvgRef.current.innerHTML;
        if (array[i].ColorsFound) {
          for (let j = 0; j < array[i].ColorsFound.length; j++) {
            if (array[i].ColorsFound[j] == AciveShapeColor) {
              array[i].ColorsFound[j] = array[i].textColor;
              setAciveShapeColor(array[i].textColor);
              break;
            }
          }
        }
        array[i].textColor = null;
        break;
      }
    }
    setLayersData(array);
  };

  const ChangeColor = (element) => {
    for (let i = 0; i < element.length; i++) {
      if (element[i].nodeName != "#text" && element[i].nodeName != "g") {
        if (element[i].attributes) {
          for (const data of element[i].attributes) {
            if (data.name == "fill") {
              if (data.value == AciveShapeColor) {
                data.value = value.textColor;
              }
            }
          }
        }
      }
      if (element[i].childNodes.length != 0) {
        ChangeColor(element[i].childNodes);
      }
    }
  };

  useEffect(() => {
    if (value.textColor != null) {
      ChangeColor(SvgRef.current.children[0].childNodes);
      Update("value.textColor");
    }
  }, [value.textColor]);

  // useEffect(() => {
  //     if (value.transparency) {
  //         SvgRef.current.children[0].children[0].setAttribute('fill', "transparent");
  //         console.log('from transparency');
  //         Update()
  //     }
  //     else {
  //         if (value.textColor) {
  //             SvgRef.current.children[0].children[0].setAttribute('fill', value.textColor);
  //             console.log('from transparency');
  //             Update()
  //         }
  //     }
  // }, [value.transparency])

  // useEffect(() => {
  //     if (value.strokeColor != null) {
  //         SvgRef.current.children[0].children[0].setAttribute('stroke', value.strokeColor)
  //         console.log('from strokeColor');
  //         Update()
  //     }
  // }, [value.strokeColor])

  // useEffect(() => {
  //     if (value.stroke != 0) {
  //         SvgRef.current.children[0].children[0].setAttribute('stroke-width', value.stroke)
  //         Update()
  //     }
  // }, [value.stroke])

  let testArray = [];

  const FindChilds = (parent) => {
    for (let i of parent) {
      if (i.nodeName != "#text" && i.nodeName != "g") {
        if (i.attributes) {
          for (const data of i.attributes) {
            if (data.name == "fill") {
              let check = false;
              for (const c of testArray) {
                if (c == data.value) {
                  check = true;
                  break;
                }
              }
              if (!check) {
                testArray.push(data.value);
              }
            }
          }
        }
      }
      if (i.childNodes.length != 0) {
        FindChilds(i.childNodes);
      }
    }
    return true;
  };

  const [readed, setreaded] = useState(false);

  useEffect(() => {
    if (SvgRef.current && !readed) {
      SvgRef.current.children[0].setAttribute("preserveAspectRatio", "none"); // Setting aspectratio of all SVG shapes
      if (FindChilds(SvgRef.current.children[0].childNodes)) {
        const array = Array.from(LayersData);
        if (array)
          for (let i = 0; i < array.length; i++) {
            if (array[i].key == value.key) {
              array[i].ColorsFound = testArray;
              break;
            }
          }
        setLayersData(array);
      }
      setreaded(true);
    }
  }, []);

  return (
    <svg
      ref={SvgRef}
      id={"default-shape-" + value.key}
      key={index}
      
      width={"100%"}
      height={"100%"}
      preserveAspectRatio="none"
      xmlSpace="preserve"
      x="0px"
      y="0px"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      draggable={false}
      className="basicShapeTag basicShapeIdentityClass"
      dangerouslySetInnerHTML={{ __html: value.svgContent }}
      // fill="#838383"
      // enableBackground = "#838383"
      style={{
        transform:fromPreview ? `rotate(${value.rotateAngle}deg) ` + value.flip  : value.flip
          ?  (!CanvasDisplay && InLock ? `rotate(${value.rotateAngle}deg) ` : "") + value.flip 
          : !CanvasDisplay && InLock
          ? ` rotate(${value.rotateAngle}deg)`
          : "",
        opacity: value.opacity,
        zIndex: -1,
        display: value.InMultiDrag ? "none" : "block",
      }}
    ></svg>
  );
};
export default ShapesComp;
